import { render, staticRenderFns } from "./NotificationSettingsGrid.vue?vue&type=template&id=46aa4910&"
import script from "./NotificationSettingsGrid.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports